import Vue from 'vue';
import noty from './noty.service';

export default {
  async getByPlayer(playerId, filter) {
    return (await Vue.http.post(`/api/pins/byplayer/${playerId}`, filter)).data;
  },
  async getByClient(clientId, filter) {
    return (await Vue.http.post(`/api/pins/byclient/${clientId}`, filter)).data;
  },
  async create(playerId, value, currency, branch, description, isDemo) {
    let p = (await Vue.http.post(`/api/pins/player/${playerId}/create`, { value, currency, branch, description, isDemo })).data;
    noty.success('Pin created successfully');
    return p;
  },
  async createFreePin(clientId, value, currency, branch, description, isDemo) {
    let p = (await Vue.http.post(`/api/pins/client/${clientId}/create`, { value, currency, branch, description, isDemo })).data;
    noty.success('Pin created successfully');
    return p;
  },
  async createBonusPin(clientId, value, currency, branch, description, isDemo) {
    let p = (await Vue.http.post(`/api/pins/client/${clientId}/create/bonus`, { value, currency, branch, description, isDemo })).data;
    noty.success('Pin created successfully');
    return p;
  }
}



// WEBPACK FOOTER //
// ./src/services/pin.service.js